import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IsActiveMatchOptions, Router, RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NavigationItem } from '../../layouts/main-layout/navigation-items';

// compara só o caminho, para o item seguir ativo em rotas como /formulario?id=1
const MATCH_OPTIONS: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  matrixParams: 'ignored',
  fragment: 'ignored'
};

@Component({
  selector: 'app-side-navigation-item',
  standalone: true,
  imports: [NgTemplateOutlet, RouterModule, NzIconModule],
  templateUrl: './side-navigation-item.component.html',
  styleUrl: './side-navigation-item.component.scss'
})
export class SideNavigationItemComponent implements OnChanges {
  @Input({ required: true }) item!: NavigationItem;
  @Input() expanded = false;
  @Input() isLink = false;
  @Output() expandRequest = new EventEmitter<void>();

  protected readonly router = inject(Router);
  open = false;

  ngOnChanges(): void {
    // ao expandir o menu, já abre o grupo da rota atual
    if (this.expanded && this.hasActiveLink) this.open = true;
  }

  get isActive(): boolean {
    return !!this.item.route && (this.router.isActive(this.item.route, MATCH_OPTIONS)
      || (this.item.route === '/home' && this.router.isActive('/referencias-encargos', MATCH_OPTIONS)));
  }

  get hasActiveLink(): boolean {
    return !!this.item.links?.some(link => !!link.route && this.router.isActive(link.route, MATCH_OPTIONS));
  }

  get showActiveTag(): boolean {
    return this.isActive || (this.hasActiveLink && !(this.expanded && this.open));
  }

  onClick(): void {
    if (!this.item.links) return;
    if (!this.expanded) {
      this.open = true;
      this.expandRequest.emit();
      return;
    }
    this.open = !this.open;
  }
}
